import { Button, ButtonVariant, Popover as ElPopover, Icon, Position, Tag } from '@blueprintjs/core'
import { useRef } from 'react'
import { ID } from 'src/libs/interfaces/layouts'
import IScalarForm from 'src/libs/scalars/interface/IScalarForm'
import Scalar from 'src/libs/scalars/scalars/Scalar'
import { __ } from 'src/libs/utilities'
import { useSyncState } from 'src/modules/pe-basic-module/hooks/useSyncState'

export interface IPopoverMultiProps extends IScalarForm{
    
}
const PopoverMulti = ( props: IPopoverMultiProps ): JSX.Element => {
    return <Scalar 
        { ...props } 
        enabledForm={<PopoverMultiEnabled {...props} />}
        desabledForm={<PopoverMultiDisabled {...props} />}
    /> 
}  

export default PopoverMulti

export const PopoverMultiEnabled = (props: IPopoverMultiProps) : JSX.Element =>  {
    const value: (string | IValue)[] = Array.isArray(props.value || props.default) 
        ?
        props.value || props.default
        :
        [ props.value || props.default ]
    
    const _value: IValue[] = value.map( v => {        
        return typeof ( v ) === "object" && !!v._id
            ? 
            v
            : 
            {
                _id: v as ID,
                title: (v || "").toString(),
                img: props.values?.find( vv => vv._id === v )?.img,
                height: props.height || 45,
                description: props.values?.find( vv => vv._id === v )?.description || "",
            } 
    })
    const onClick = ( i:number ) => {
        const v = [ ...props.values || [] ].filter( (val, n) => n === i )[0]
        const newVal = _value.find( vv => vv._id === v._id )
            ?
            _value.filter( vv => vv._id !== v._id )
            :
            [ ..._value, v ]        
        if( props.onChange && v ) {
            props.onChange(
                newVal, 
                props.field, 
                ""
            )
        }
    }
    const cards: any = props.values?.map((value: any, i) => {
        const checked = !!_value.filter( v => v._id === value._id ).length 
        return <ChooserBtn 
            key={i}
            value={value}
            checked={checked}
            width={props.width}
            height={props.height}
            onClick={() => onClick(i)}
        />
    })

    return <ElPopover
        position={ Position.LEFT }
        interactionKind={"click"}
        className='w-100'
        content={
            <div className='d-flex flex-wrap sub-menu-container overflow-y-auto'>
                { cards }
            </div>
        }
    >
        <div className=''>
            <Button
                role="button"
                className="btn-stretch" 
                fill
                variant={ ButtonVariant.MINIMAL } 
            >
                <div className="w-100 flex-centered flex-column position-relative">
                    <div className="w-100 d-flex flex-wrap bg-dark py-2 px-4" style={{ minHeight: 82 }}>
                        {
                            _value.map((v: IValue) =>  <SelectedSingle key={v._id} val={v} />)
                        }
                    </div>         
                    <div className="h-100 d-flex position-absolute top left m-2">
                        <Icon icon="caret-left" className='my-auto' />
                    </div>
                    <div className="h-100 d-flex position-absolute top right m-2">
                        <Icon icon="caret-right" className='my-auto' />
                    </div>
                </div>
            </Button> 
        </div>
    </ElPopover>
}

interface IValue {
    _id: ID
    img?: string
    title: string,
    description?: string,
    icon_opacity? : number
    width? : string | number
    height? : string | number

}
interface ISelectedSingleProps extends IPopoverMultiProps {
    val: IValue
}
const SelectedSingle = ({val, ...props}:ISelectedSingleProps): JSX.Element => {
    const animated  = useSyncState<string>( "animate" )
    const onMouseOver = () => {
        animated.set( `animated ${ val._id }` )
    }
    const onMouseLeave = () => {
        animated.set( `animate` )
    }
    return <div className="w-50 flex-centered flex-column" onMouseOver={onMouseOver} onMouseLeave={onMouseLeave}>
        <img
            src={ val.img }
            alt={ "" }
            className={`scalar-imgage-radio-img mb-1  ${animated.get()} img-plain`}
            style={{
                height: (parseInt( (props.height || 50).toString() )) - 20,
                top: 0
            }}
        />
        <div className="title text-light small text-wrap text-uppercase title px-2 text-center" style={{...props.style, maxWidth: "100%" }}>
            { __(val.title) }
        </div>
        <div 
            className="scalar-imgage-radio-description text-light " 
            style={{ maxWidth: "100%" }}
        >
            { __(val.description || "") }
        </div>
    </div>
}

interface IChooserBtnProps {
    value: IValue
    width?: string | number 
    height?: string | number 
    checked: boolean
    onClick: () => void
}
const ChooserBtn = ({value, checked, onClick, ...props}: IChooserBtnProps) : JSX.Element => {  
    const animated  = useSyncState<string>( "animate" )
    const onMouseOver = () => {
        animated.set( `animated ${ value._id }` )
    }
    const onMouseLeave = () => {
        animated.set( `animate` )
    }
    return <Button 
        role="button"
        className="w-33 btn-stretch p-0"
        onClick={() => onClick( )}
        onMouseOver={onMouseOver}
        onMouseLeave={onMouseLeave}
        data-v={ value._id }
        fill
        variant={ ButtonVariant.MINIMAL }
        style={{width: value.width || props.width || 100}} 
    >
        <div className={`w-100 d-flex ${checked ? "bg-contrast text-plain" : ""}`}> 
            <div className={`w-100 flex-centered flex-column flex-grow-100 pt-2`}>
                <img
                    src={ value.img }
                    alt={ "" }
                    className={`scalar-imgage-radio-img mb-1 ${checked ? "img-plain" : ""}  ${animated.get()}`}
                    style={{
                        height: (parseInt( ( value.height || props.height || 110).toString() ) ) - 20,
                        top: 0,
                        opacity: checked
                            ? 
                            value.icon_opacity
                                ? 
                                value.icon_opacity
                                : 
                                1
                            : 
                            0.33,
                    }}
                />
                <div className="micro text-wrap text-uppercase title px-2 text-center" style={{...props.style, maxWidth: "100%" }}>
                    { __(value.title) }
                </div>
                <div 
                    className="scalar-imgage-radio-description" 
                    style={{ maxWidth: "100%" }}
                >
                    { __(value.description || "") }
                </div> 
            </div>
        </div> 
    </Button>
}

export const PopoverMultiDisabled = (props: IScalarForm) : JSX.Element => {
     const checkedValue = props.values?.filter( v => v._id === props.value )[0]
        const _value = typeof (props.value || props.default ) === "object" 
            ? 
            (props.value || props.default )
            : 
            {
                _id: (props.value || props.default ),
                title: (props.value || props.default ),
                img: "",
                height: 45
            } 
        return checkedValue
            ?
            <div>
                <img
                    src={checkedValue.img}
                    alt={_value.title}
                    className="scalar-imgage-radio-img"
                    style={{
                        height: checkedValue.height,
                        top: 0 
                    }}
                />
                <div>{ _value.title }</div>
            </div>
            :
            <Tag>
                { _value.title }
            </Tag>
}